<script setup>
/**
 * Bottone DaisyUI (via slot per il contenuto) con una barra di countdown che
 * SCORRE ALL'INTERNO, in basso. Non reimplementa il `.btn`: applica le classi
 * DaisyUI passate come prop e sovrappone solo la lineetta animata.
 *
 * Parametri (tutti via class, così restano DaisyUI/Tailwind-native):
 *   - buttonClass  : variante/colore del bottone (es. "btn-primary")
 *   - barClass     : colore della barra (es. "bg-white")
 *   - roundedClass : corner radius (es. "rounded-full") — applicato a bottone e clip
 *   - wrapperClass : classi extra sul root (ombra, pointer-events, ecc.)
 *   - seconds      : durata del countdown
 *
 * Attributi nativi (data-*, aria-*, @click) fanno fallthrough sul <button>
 * interno (inheritAttrs:false + v-bind="$attrs"). Emette `timeout` a fine barra.
 */
defineOptions({ inheritAttrs: false })

defineProps({
  seconds: { type: Number, default: 45 },
  buttonClass: { type: String, default: 'btn-primary' },
  barClass: { type: String, default: 'bg-white' },
  roundedClass: { type: String, default: 'rounded-full' },
  wrapperClass: { type: String, default: '' }
})

const emit = defineEmits(['timeout'])
</script>

<template>
  <div
    class="relative inline-flex overflow-hidden"
    :class="[roundedClass, wrapperClass]"
  >
    <button
      type="button"
      class="btn w-full"
      :class="[buttonClass, roundedClass]"
      v-bind="$attrs"
    >
      <slot />
    </button>

    <!-- Barra countdown: scorre ALL'INTERNO del bottone, in basso -->
    <div class="pointer-events-none absolute inset-x-0 bottom-0 h-1 overflow-hidden">
      <div
        class="countdown-bar h-full"
        :class="barClass"
        :style="{ animationDuration: `${seconds}s` }"
        @animationend="emit('timeout')"
      />
    </div>
  </div>
</template>

<style scoped>
.countdown-bar {
  width: 100%;
  animation-name: countdown-bar;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes countdown-bar {
  from { width: 100%; }
  to { width: 0%; }
}
</style>
